import React, { useEffect, useState } from "react";
import { Col, Container, Row, Table } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import toast from "react-hot-toast";
import "./../PurchaseRequest.css";
import NoDataImg from "../../../../Assets/Images/no-data-img.png";
import ApproveModal from './../../../../Components/Modals/ApproveModal';
import TableTemp from "../../../../Components/TableTemplate/Table";
import Moment from "moment";
import AddNoteModal from './AddNoteModal';
import { getPurchaseRequest, updatePurchaseRequestStatus, deletePurchaseRequest } from "../../../../Helpers/apiCalls/Purchases/purchaseRequestApi";
import DeleteModal from './../../../../Components/Modals/DeleteModal';
import { TokenExpiry, getType, numberFormat, toastStyle } from "../../../../Helpers/Utils/Common";
import Modal from "antd/es/modal/Modal";
import Navbar from "../../../../Components/Navbar/Navbar";
import noDataImg from "../../../../Assets/Images/no-data-img.png";
import Footer from "../../../../Components/Footer/Footer";

export default function ReviewPurchaseRequest() {
    const { id } = useParams();
    let navigate = useNavigate();
    const accountType = getType();

    const [inactive, setInactive] = useState(true);
    const [isClicked, setIsClicked] = useState(false);
    const [transaction, setTransaction] = useState([]);
    const [items, setItems] = useState([{}]);
    const [preview, setPreview] = useState(false);
    const [previewFile, setPreviewFile] = useState("");
    const [fileList, setFileList] = useState([]);
    const [notes, setNotes] = useState([{
        details: "sample",
        added_by_name: "Mark Lee"
    }]);
    const [addDetails, setAddDetails] = useState({
    })
    /* print modal handler */
    const [showApproveModal, setShowApproveModal] = useState(false);
    const handleShowApproveModal = () => setShowApproveModal(true);
    const handleCloseApproveModal = () => setShowApproveModal(false);
    // Add note modal
    const [showAddNoteModal, setShowAddNoteModal] = useState(false);
    const handleShowAddNoteModal = () => setShowAddNoteModal(true);
    const handleCloseAddNoteModal = () => setShowAddNoteModal(false);

    // create po modal
    const [showCreatePOModal, setShowCreatePOModal] = useState(false);
    const handleShowCreatePOModal = () => setShowCreatePOModal(true);
    const handleCloseCreatePOModal = () => setShowCreatePOModal(false);

    const [showDisapproveModal, setShowDisapproveModal] = useState(false);
    const handleShowDisapproveModal = () => setShowDisapproveModal(true);
    const handleCloseDisapproveModal = () => setShowDisapproveModal(false);

    /* delete modal handler */
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const handleShowDeleteModal = () => setShowDeleteModal(true);
    const handleCloseDeleteModal = () => setShowDeleteModal(false);

    const [printPI, setPrintPI] = useState([]);

    // async function handlePrintPI() {
    //     toast.loading("Printing Transaction", { style: toastStyle() });
    //     handleCloseApproveModal();
    //     setTimeout(() => {
    //         toast.dismiss();
    //         Print();
    //     }, 1000);
    // }

    // function Print() {
    //     let printContents = document.getElementById("printablediv").innerHTML;
    //     let originalContents = document.body.innerHTML;
    //     document.body.innerHTML = printContents;
    //     window.print(printContents);
    //     document.body.innerHTML = originalContents;
    //     refreshPage();
    // }

    
    async function handleApprove() {
        setIsClicked(true)
        const response = await updatePurchaseRequestStatus(id, "approved");
        if(response.data) {
            toast.success("Successfully Approved Purchase Request", { style: toastStyle() });
            handleCloseApproveModal();
            setTimeout(() => {
                navigate("/purchaserequest")
            }, 1000);
        } else {
            toast.error("Something went wrong", { style: toastStyle() });
            handleCloseApproveModal();
            // setTimeout(() => {
            //     navigate("/purchaserequest")
            // }, 1000);
        }
        setIsClicked(false)
    }

    async function handleDisapprove() {
        setIsClicked(true)
        const response = await updatePurchaseRequestStatus(id, "disapproved");
        if(response.data) {
            toast.success("Successfully Dispproved Purchase Request", { style: toastStyle() });
            handleCloseApproveModal();
            setTimeout(() => {
                navigate("/purchaserequest")
            }, 1000);
        } else {
            toast.error("Something went wrong", { style: toastStyle() });
            handleCloseApproveModal();
            // setTimeout(() => {
            //     navigate("/purchaserequest")
            // }, 1000);
        }
        setIsClicked(false)
    }

    async function handleSubmit() {
        const response = await updatePurchaseRequestStatus(id, "submitted");
        if(response.data) {
            toast.success("Successfully Submitted Purchase Request", { style: toastStyle() });
            setTimeout(() => {
                navigate("/purchaserequest")
            }, 1000);
        } else {
            toast.error("Something went wrong", { style: toastStyle() });
            // setTimeout(() => {
            //     navigate("/purchaserequest")
            // }, 1000);
        }
    }

    async function handleDeletePurchaseRequest() {
        const response = await deletePurchaseRequest(id);
        if (response.data) {
            toast.success("Purchase Request Deleted Successfully!", {
                style: toastStyle(),
            });
            setTimeout(() => navigate("/purchaserequest"), 1000);
        } else {
            TokenExpiry(response);
            toast.error("Error Deleting Purchase Request", {
                style: toastStyle(),
            });
        }
    }

    async function fetchPurchaseRequest() {
        setFileList([])
        setAddDetails([]);
        const response = await getPurchaseRequest({id: id});
        if(response.data) {
            var data = response.data.data.map((data) => {
                var info = data;
                info.has_attachment = data.purchase_request_attachments?.length > 0 ? true : false;
                return info
            })
            setAddDetails(data[0]);
            
            let remarksdata = [];
            for(let i = 0; i < data[0].purchase_request_remarks.length; i++) {
                remarksdata.push({
                    details: data[0].purchase_request_remarks[i].details,
                    added_by_name: data[0].purchase_request_remarks[i].added_by_name
                })
            }

            setNotes(remarksdata);

            var itemsdata = data[0].purchase_request_items.map((data) => {
                var info = data;
                info.item_id_value = {
                    label: data.item_name,
                    value: data.item_id,
                }
                return info
            })

            setFileList(response.data.data[0].purchase_request_attachments);
            setItems(itemsdata);
        }
    }

    function renderTable() {
        return (
            <Table>
                <thead>
                    <tr>
                        <th>quantity</th>
                        <th>unit</th>
                        <th>complete item description</th>
                        <th className="text-end">selling price</th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th>remarks</th>
                    </tr>
                </thead>
                <tbody>
                    {items.map((item) => {
                        return (
                            <tr key={item.id}>
                                <td>{parseFloat(item.quantity)}</td>
                                <td>{item.uom}</td>
                                <td>{item.description}</td>
                                <td className="text-end">{parseFloat(item.selling_price)}</td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td>{item.remark}</td>
                            </tr>
                        );
                    })}
                </tbody>
            </Table>
        );
    }


    useEffect(() => {
        fetchPurchaseRequest(id);
    }, []);

    return (
        <div>
            <div className="page">
                <Navbar
                    onCollapse={(inactive) => {
                        setInactive(inactive);
                    }}
                    active={"PURCHASES"}
                />
            </div>
            <div className={`manager-container ${inactive ? "inactive" : "active"}`}>
                
                <Row className="mb-4">
                    <Col xs={12} lg={9}>
                        {
                            (addDetails.status === "approved" || addDetails.status === "pending") && (
                                <>
                                    <h1 className="page-title ps-2 ms-3 ms-md-0 ps-md-0 ms-md-0 fs-2"> VIEW PURCHASE REQUEST </h1>
                                </>
                            )
                        }
                        {
                            addDetails.status === "submitted" && (
                                <>
                                    <h1 className="page-title ps-2 ms-3 ms-md-0 ps-md-0 ms-md-0 fs-2"> REVIEW PURCHASE REQUEST </h1>
                                </>
                            )
                        }
                    </Col>
                    <Col xs={12} lg={3}>
                        <span className="PI-header2">PURCHASE REQUEST NO. {id}</span>
                    </Col>
                </Row>

                <div className="review-form mb-3">
                        <Row className="review-container py-3">
                            <Row>
                                <Col xs={8} lg={3}>
                                <span className="review-label ">
                                        Department Name
                                    </span> <br />
                                    <span className="review-data ">
                                        {addDetails.department_name}
                                    </span>
                                </Col>
                                <Col xs={4} lg={3}>
                                <span className="review-label ">
                                        Branch
                                    </span> <br />
                                    <span className="review-data ">
                                        {addDetails.branch}
                                    </span>
                                </Col>
                                <Col xs={6} lg={3} className="mt-2 mt-lg-0">
                                <span className="review-label ">
                                        Request Date
                                    </span> <br />
                                    <span className="review-data ">
                                        {Moment(addDetails.request_date).format("MMM DD, YYYY")}
                                    </span>
                                </Col>
                                <Col xs={6} lg={3} className="mt-2 mt-lg-0">
                                <span className="review-label ">
                                        Required Date
                                    </span> <br />
                                    <span className="review-data ">
                                        {Moment(addDetails.required_date).format("MMM DD, YYYY")}
                                    </span>
                                </Col>
                            </Row>
                        </Row>
                        <Row className="review-container py-3">
                            <Row>
                                <Col xs={6} lg={3}>
                                <span className="review-label ">
                                        OIC / Head
                                    </span> <br />
                                    <span className="review-data ">
                                        {addDetails.oic}
                                    </span>
                                </Col>
                                <Col xs={6} lg={3}>
                                <span className="review-label ">
                                        Requested By
                                    </span> <br />
                                    <span className="review-data ">
                                        {addDetails.requested_by_name}
                                    </span>
                                </Col>
                                <Col xs={12} lg={3} className="mt-2 mt-lg-0">
                                <span className="review-label ">
                                        Remarks
                                    </span> <br />
                                    <span className="review-data ">
                                        {addDetails.remarks}
                                    </span>
                                </Col>
                            </Row>
                        </Row>
                    

                    {/* INVOICES */}
                    <div className="mt-4 d-flex flex-column">
                        <span className="review-data mb-2 nc-modal-custom-row">
                            PURCHASED ITEMS
                        </span>
                        <div className="review-purchased-items">
                            {renderTable()}
                        </div>
                    </div>
                    <div className="mt-4 noPrint mx-3">
                        <Row className="review-data mb-2">
                            FILE ATTACHMENTS
                        </Row>
                        <Row className="">
                            {
                                fileList && fileList.map((attachment) => (
                                    <Col xs={1} onClick={() => {setPreviewFile(attachment.file_url); setPreview(true)}} className="cursor-pointer preview-container">
                                        <img src={attachment.file_url}  className="img-preview"/>
                                    </Col>
                                ))
                            }
                            {
                                !fileList || fileList.length === 0 && 
                                <Col xs={1}>
                                <div className="no-data-cont d-flex justify-content-left preview-container">
                                    <img src={noDataImg} alt="no data found" className="img-preview"/>
                                </div>
                                </Col>
                            }
                        </Row>
                    </div>
                </div>
                {
                        addDetails.status === "pending" && (
                            <>

                                <div className="d-flex justify-content-end pt-1 pb-5">
                                    <button
                                        type="button"
                                        className="button-secondary me-3"
                                        onClick={() =>
                                            navigate("/purchaserequest")
                                        }
                                    >
                                        Close
                                    </button>
                                    <button
                                        type="button"
                                        className="button-warning me-3"
                                        onClick={handleShowDeleteModal}
                                    >
                                        Delete
                                    </button>
                                    <button
                                        type="button"
                                        className="button-tertiary me-3"
                                        onClick={() => navigate("/purchaserequest/edit/" + id)}
                                    >
                                        Edit
                                    </button>
                                    <button
                                        type="button"
                                        className="button-primary"
                                        onClick={handleSubmit}
                                    >
                                        Submit
                                    </button>
                                </div>
                            </>
                        )
                    }
                    {
                        addDetails.status === "generated" && (
                            <>
                                <div className="d-flex justify-content-end pt-1 pb-5">
                                    <button
                                        type="button"
                                        className="button-secondary"
                                        onClick={() =>
                                            navigate("/purchaserequest")
                                        }
                                    >
                                        Close
                                    </button>
                                </div>
                            </>
                        )
                    }       
                    {
                        addDetails.status === "approved" && (
                            <>

                                <div className="d-flex justify-content-end pt-1 pb-5">
                                    <button
                                        type="button"
                                        className="button-secondary me-3"
                                        onClick={() =>
                                            navigate("/purchaserequest")
                                        }
                                    >
                                        Close
                                    </button>
                                    <button
                                        type="button"
                                        className="button-primary me-3"
                                        onClick={(e) => navigate("/purchaserequest/print/" + id)}
                                    >
                                        Print
                                    </button>
                                    {
                                        (accountType === "admin" || accountType === "purchasing_officer")  && (
                                            <>
                                                <button
                                                    type="button"
                                                    className="button-tertiary me-3"
                                                    onClick={handleShowAddNoteModal}
                                                >
                                                    Add Note
                                                </button>
                                                <button
                                                    type="button"
                                                    className="button-primary"
                                                    onClick={(e) => navigate("/purchaserequest/generate/" + id)}
                                                >
                                                    Create PO
                                                </button>
                                            </>
                                        )
                                    }
                                </div>
                            </>
                        )
                    }
                    {
                        addDetails.status === "submitted" && (
                            <>
                                <div className="d-flex justify-content-end pt-1 pb-3">
                                    <button
                                        type="button"
                                        className="button-secondary me-3"
                                        onClick={() =>
                                            navigate("/purchaserequest")
                                        }
                                    >
                                        Close
                                    </button>
                                    <button
                                        type="button"
                                        className="button-primary me-3"
                                        onClick={() => navigate("/purchaserequest/edit/" + id)}
                                    >
                                        Edit
                                    </button>
                                    {
                                        (accountType === "admin" || accountType === "branch_oic")  && (
                                            <>
                                                <button
                                                    type="button"
                                                    className="button-warning-fill me-3"
                                                    onClick={handleShowDisapproveModal}
                                                >
                                                    Disapprove
                                                </button>

                                                <button
                                                    type="button"
                                                    className="button-tertiary"
                                                    onClick={handleShowApproveModal}
                                                >
                                                    Approve
                                                </button>
                                            </>
                                        )
                                    }
                                </div>
                            </>
                        )
                    }

                <div className="mb-5 pb-5 ">
                    <div className="tab-content">
                        <h5 className="PI-payment-info mt-3 ms-3">NOTES</h5>
                        <TableTemp
                            tableHeaders={[
                                "DETAILS",
                                "ADDED BY",
                            ]}
                            headerSelector={[
                                "details",
                                "added_by_name",
                            ]}
                            tableData={notes}
                            // tableType="notes"
                        />
                    </div>
                </div>
            </div>

            <AddNoteModal
                id={id}
                show={showAddNoteModal}
                hide={handleCloseAddNoteModal}
                type="approve"
                // handler={handlePrintPI}
            />
            
            <ApproveModal
                show={showApproveModal}
                hide={handleCloseApproveModal}
                type="approve"
                text="approve purchase request"
                page="transaction"
                handler={handleApprove}
                isClicked={isClicked}
            />
            
            <ApproveModal
                show={showDisapproveModal}
                hide={handleCloseDisapproveModal}
                type="disapprove"
                text="disapprove purchase request"
                page="transaction"
                handler={handleDisapprove}
                isClicked={isClicked}
            />

            <DeleteModal
                isClicked={isClicked}
                show={showDeleteModal}
                onHide={() => handleCloseDeleteModal()}
                text="purchase request"
                onDelete={() => handleDeletePurchaseRequest()}
            />
            <Modal open={preview} title={""} footer={null} onCancel={()=>setPreview(false)}>
                <img
                    alt="example"
                    style={{
                    width: '100%',
                    }}
                    src={previewFile}
                />
            </Modal>
            <Footer/>
        </div>
    );
}
